import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { PricingNumericTypeValues } from "@/screens/Pricing/constants"

interface NumericTypeFieldProps {
  name: string
}

const NumericTypeField: FC<NumericTypeFieldProps> = ({ name }) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <ToggleButtonGroup
          exclusive
          size='small'
          value={field.value}
          onChange={(_, value) => {
            if (value !== null) field.onChange(value)
          }}
          className='h-10'
        >
          {Object.values(PricingNumericTypeValues).map((v, index) => (
            <ToggleButton
              key={`pricing.bulk-update-form.${name}-numeric-type.${index}`}
              value={v}
              className='min-w-10 px-3'
            >
              {v}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      )}
    />
  )
}

export default NumericTypeField
